export const capitalizeString = (str) => {
  if (!str) return null;

  return str.at(0).toUpperCase() + str.substring(1);
};
